interface Props {
  activeColor: string;
}
const WorkSpaceIcon = (props: Props) => {
  const activeColor = props.activeColor ? props.activeColor : "#0f1560";
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="4"
        y="4"
        width="6"
        height="6"
        rx="1"
        stroke={activeColor}
        strokeWidth="1.8"
      />
      <rect
        x="14"
        y="4"
        width="6"
        height="6"
        rx="1"
        stroke={activeColor}
        strokeWidth="1.8"
      />
      <rect
        x="4"
        y="14"
        width="6"
        height="6"
        rx="1"
        stroke={activeColor}
        strokeWidth="1.8"
      />
      <rect
        x="14"
        y="14"
        width="6"
        height="6"
        rx="1"
        stroke={activeColor}
        strokeWidth="1.8"
      />
    </svg>
  );
};

export default WorkSpaceIcon;
